export type FreeformOperation =
  | "equals"
  | "does_not_equal"
  | "is_set"
  | "is_not_set"
  | "contains"
  | "does_not_contain"
  | "before"
  | "after"
  | "less_than"
  | "greater_than";

export interface FreeformFilter {
  field: string;
  operation: FreeformOperation;
  value?: string | number;
}

export interface FreeformFieldOption {
  value: string;
  label: string;
  valueType: "string" | "number" | "date";
}

export const NO_VALUE_OPERATIONS: FreeformOperation[] = ["is_set", "is_not_set"];

export const compileFreeformFilter = (filter: FreeformFilter): Record<string, unknown> => {
  const op = filter.operation;
  if (NO_VALUE_OPERATIONS.includes(op)) {
    return {
      [filter.field]: op === "is_set" ? { $exists: true, $nin: [null, ""] } : { $in: [null, ""] },
    };
  }
  if (op === "equals") return { [filter.field]: filter.value };
  if (op === "does_not_equal") return { [filter.field]: { $ne: filter.value } };
  if (op === "contains") return { [filter.field]: { $regex: filter.value, $options: "i" } };
  if (op === "does_not_contain") {
    return { [filter.field]: { $not: { $regex: filter.value, $options: "i" } } };
  }
  if (op === "before" || op === "less_than") return { [filter.field]: { $lt: filter.value } };
  return { [filter.field]: { $gt: filter.value } };
};

export const isFreeformFilterValueComplete = (filter: FreeformFilter): boolean => {
  if (!filter.field) return false;
  if (NO_VALUE_OPERATIONS.includes(filter.operation)) return true;
  return filter.value !== undefined && filter.value !== "";
};
